import Axios from "axios";

const getDefaultState = () => {
  return {
    widgets: [],
    dashboards: [],
    dashboard: {}
  }
}
const state = getDefaultState()

const getters = {
  dashboardData (state) {
    return state.widgets
  },
  dashboards (state) {
    return state.dashboards
  },
  dashboard (state) {
    return state.dashboard
  },
  widgetsReady (state) {
    return state.widgetsReady
  }
}

const mutations = {
  addWidgetData(state, widget) {
    let index = state.widgets.findIndex( w => w.id === widget.id)
    if (index != -1) {
      state.widgets.splice(index, 1)
    }
    state.widgets.push(widget)
  },
  resetWidgetData(state) {
    state.widgets = []
    Object.assign(state, getDefaultState())
  },
  setDashboards (state, payload) {
    state.dashboards = payload
  },
  setDashboard (state, payload) {
    state.dashboard = payload
  }
}

const actions = {
  async getDashboards({ commit }) {
    try {
      const payload = await Axios.get('dashboards')
      commit('setDashboards', payload.data.data)
    }
    catch (e) {
      return console.log(e)
    }
  },
  async getDashboard({ commit }, id) {
    try {
      const payload = await Axios.get(`dashboards/${id}`)
      commit('setDashboard', payload.data)
    }
    catch (e) {
      return console.log(e)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
